import React from "react";

import { OrderProvider } from "../contexts/order";

import BarcodeForm from "./modals/BarcodeForm";
import OrderColorForm from "./modals/OrderColorForm ";
import OrderPaperForm from "./modals/PaperOredrForm";
import ModalAddCore from "./orderPage/dataModals/ModalAddCore";
import ModalAddPaperSize from "./orderPage/dataModals/ModalAddPaperSize";
import ModalAddPaperType from "./orderPage/dataModals/ModalAddPaperType";
import ModalAddLabelSize from "./orderPage/dataModals/ModalAddLabelSize";
import ModalAddUp from "./orderPage/dataModals/ModalAddUp";
import AddOrderComponent from "./addOrder/addOrderComponent";
import { ErrorBoundary } from "react-error-boundary";
import FallbackComponent from "./fallbackRenders/FallbackComponent";

export default function AddOrderPage() {
  return (
    <div className="p-4 h-full overflow-auto">
      <ErrorBoundary fallbackRender={FallbackComponent}>
        <OrderProvider>
          <BarcodeForm />
          <OrderPaperForm />
          <ModalAddCore />
          <ModalAddPaperSize />
          <ModalAddPaperType />
          <OrderColorForm />
          <ModalAddLabelSize />
          <ModalAddUp />
          <AddOrderComponent />
        </OrderProvider>
      </ErrorBoundary>
    </div>
  );
}
